import Actions from '../../action'
const initialState = {
    isLoading: false,
    subscribedList: [],
    error: false
}
export default (state = initialState, action = {}) => {
    switch (action.type) {
        case Actions.GET_SUBSCRIBED_LIST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.GET_SUBSCRIBED_LIST_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                subscribedList: action.data.response,
                error: false
            };
        }
        case Actions.GET_SUBSCRIBED_LIST_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: action.error,
            };
        }
        default:
            return state;
    }
};


